<template>
  <div class="live-wrapper">
    <!-- PLAYER -->
    <div class="player-card">
      <div class="video-container">
        <video
          ref="video"
          controls
          autoplay
          muted
          playsinline
        ></video>

        
      </div>
    </div>

    <!-- SERVER SELECT -->
    <div class="server-panel">
      <button
        v-for="(server, index) in servers"
        :key="index"
        class="server-btn"
        :class="{ active: activeServer === server.stream_url }"
        @click="changeLink(server.stream_url)"
      >
        {{ server.name }}
      </button>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      servers: JSON.parse(localStorage.getItem('servers')) || [],
      hls: null,
    }
  },

  methods: {
    ...mapActions(['fetchUser']),

    playStream(url) {
      const video = this.$refs.video

      // destroy old instance
      if (this.hls) {
        this.hls.destroy()
        this.hls = null
      }

      // Safari (native HLS)
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = url
        video.play()
        return
      }

      // Chrome / Firefox
      if (Hls.isSupported()) {
        this.hls = new Hls({
          lowLatencyMode: true
        })
        this.hls.loadSource(url)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      } else {
        console.error('HLS not supported')
      }
    },

    changeLink(url) {
      this.playStream(url)
    }
  },

  async mounted() {
    // auth check
    const authUser = await this.fetchUser()
    if (!authUser) {
      this.$router.push('/auth/login')
      return
    }

    // auto play first server
    if (this.servers.length > 0) {
      this.playStream(this.servers[0].stream_url)
    }
  },

  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy()
    }
  }
}
</script>

<style scoped>
.live-wrapper {
  min-height: 100vh;
  background: #ffffff;
  padding: 1rem;
}

/* PLAYER CARD */
.player-card {
  max-width: 960px;
  margin: auto;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  overflow: hidden;
}

/* VIDEO */
.video-container {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f3f4f6;
}

video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* OVERLAY */
.overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #374151;
  font-size: 0.95rem;
}

.overlay.error {
  color: #ca8a04;
  font-weight: 500;
}

/* SPINNER */
.spinner {
  width: 36px;
  height: 36px;
  border: 4px solid #e5e7eb;
  border-top-color: #ca8a04;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* SERVER PANEL */
.server-panel {
  margin-top: 1.2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
}

/* SERVER BUTTON */
.server-btn {
  background: #f9fafb;
  border: 1px solid #d1d5db;
  color: #111827;
  padding: 0.55rem 0.9rem;
  border-radius: 6px;
  font-size: 0.85rem;
  transition: all 0.15s ease;
}

/* Hover */
.server-btn:hover {
  background: #f0fdf4;
  border-color: #86efac;
}

/* ACTIVE (LIGHT GREEN) */
.server-btn.active {
  background: #dcfce7;        /* light green */
  border-color: #22c55e;      /* green border */
  color: #166534;             /* dark green text */
  font-weight: 600;
}

/* Optional: small dot indicator */
.server-btn.active::before {
  content: '●';
  color: #22c55e;
  font-size: 0.6rem;
  margin-right: 6px;
  vertical-align: middle;
}
</style>